var map = {
	"./1.png": 2947,
	"./2.png": 2948,
	"./3-plus.png": 2949,
	"./3.png": 2950
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers .\.png*
// module id = 378
// module chunks = 0